<template>
  <div>
    <section class=" container section is-main-section">
      <form @submit.prevent="save">
        <div>
            <v-card-component title="Add Vehicle Pollution Details" icon="mdi-bus">
               <v-card-actions>
        <router-link :to="{ name: 'vehiclePollution' }">
          <v-btn v-if="$vuetify.breakpoint.smAndUp" elevation="1" absolute right top> <v-icon left>mdi-arrow-left</v-icon>back</v-btn>
          <v-btn v-else fixed right fab small color="grey lighten-2" elevation="1" class="mr-n2 mt-10" style="opacity:.6;"> <v-icon>mdi-arrow-left</v-icon></v-btn>
        </router-link>
      </v-card-actions>
<v-row>
<v-col>
      <v-row>
        <v-col cols="12" lg="3" sm="6" >
        <span class="body-2 font-weight-medium"> Academic Year</span>
        <span class="error--text ml-1">*</span>
        <v-autocomplete required v-model="academicYearID" key="id" @change="clearData()" class="my-0 py-1" single-line placeholder="---Select---" :items="academicYears" item-text="academicYear" item-value="id">
        </v-autocomplete>
      </v-col>
      <v-col cols="12" lg="3" sm="6">
        <span class="body-2 font-weight-medium">Select Franchisee</span>
        <span class="error--text ml-1">*</span>
        <v-autocomplete v-model="franchiseeID" key="id" @change="getVehicleList()" class="my-0 py-1" required  single-line placeholder="---Select---" :items="franchiseeArr" item-text="companyName" item-value="id">
        </v-autocomplete>
      </v-col>
    </v-row>
     <v-row>
        <v-col cols="12" lg="3" sm="6">
        <span class="body-2 font-weight-medium">Select Vehicle No</span>
        <span class="error--text ml-1">*</span>
        <v-autocomplete v-model="vehicleID" key="id" class="my-0 py-1"  required single-line placeholder="---Select---" :items="vehicleDetails" item-text="vehicleRegistrationNumber" item-value="id">
        </v-autocomplete>
      </v-col>
        <v-col cols="12" lg="3" sm="6">
        <span class="body-2 font-weight-medium"> PUC Cost <span class="error--text ml-1">*</span>  </span>
        <v-text-field v-model.trim="pucCost" step="any" required class="my-0 py-1" type="number">
        </v-text-field>
      </v-col>
          <v-col cols="12" lg="3" md="6">
              <label class="body-2 font-weight-medium"> Start Date </label>
               <span class="error--text ml-1">*</span>
              <custom-date-picker v-model="pollutionStartDate" required />
            </v-col>
      <v-col cols="12" lg="3" md="6">
              <label class="body-2 font-weight-medium"> Expiry Date </label>
               <span class="error--text ml-1">*</span>
              <custom-date-picker v-model="pollutionExpiryDate" required :minToDate="this.pollutionStartDate"  />
            </v-col>
    </v-row>
</v-col>
</v-row>
  <div class="columns form-row">
            <div class="column">
              <div class="field">
                <label class="label">
                  Upload Vehicle Pollution Details
                </label>
                <b-field class="file is-primary">
                  <b-upload @input="onFilechange()" v-model="dropFile" multiple class="file-label">
                    <span class="file-cta">
                      <b-icon class="file-icon" icon="upload"></b-icon>
                      <span class="file-label">Click to upload</span>
                    </span>
                  </b-upload>
                </b-field>
                <!-- <span class="has-text-danger">Allowed files:  .png, .jpg, .jpeg, .pdf </span> -->
<br/><br/> <!--<span class="has-text-danger">File's that are not supported will be removed automatically!</span>-->
                <span v-if="dropFile.length > 0">
                  <div class="tags" v-for="(file, i) in dropFile" :key="i">
                    <span class="tag is-primary">
                      {{ file.name }}
                    </span>
                    <button class="delete is-small" type="button" @click="deleteDropFile(i)"></button>
                  </div>
                </span>
              </div>
            </div>
          </div>
          <button class="button is-success" :disabled="hasClicked" type="submit" style="margin-top:20px;">Create</button>
  </v-card-component>
        </div>
        <div></div>
      </form>
    </section>
  </div>
</template>
<script>
import constants from '@/utils/constants'
import Utils from '@/utils'
import VCardComponent from '@/components/template/VCardComponent'
import CustomDatePicker from '@/components/template/CustomDatePicker'
export default {
  name: 'addVehiclePollution',
  components: {
    VCardComponent,
    CustomDatePicker
  },
  data () {
    return {
      total: 0,
      dropFile: [],
      vehicleID: '',
      pucCost: '',
      pollutionStartDate: '',
      pollutionExpiryDate: '',
      franchiseeID: '',
      franchiseeArr: [],
      academicYearID: '',
      academicYears: [],
      vehicleDetails: [],
      title: '',
      hasClicked: false,
      loader: true,
      isWrite: false,
      allowedFiles: [
        'png', 'jpg', 'jpeg', 'pdf'
      ]
    }
  },

  async created () {
    this.isWrite = Utils.helper.getIsWriteFun(this.$route)
    await this.getYear()
    await this.getFranchiseeList()
  },
  methods: {
    getVehicleList: async function () {
      try {
        this.vehicleDetails = []
        this.isLoading = true
        let getParam = {}
        getParam.franchiseeID = this.franchiseeID
        getParam.academicYearID = this.academicYearID
        this.isLoading = true
        const { data } = await http.get(`${constants.API_URL}/api/transport/vehicledetails/vehicledetails`, {
          params: getParam
        })
        if (data.length === 0) {
          this.$buefy.dialog.alert({
            title: 'No Data ',
            message: 'No Vehicle Registered With Selected Franchisee and Academic year',
            type: 'is-danger',
            hasIcon: true,
            icon: 'times-circle',
            iconPack: 'fa',
            ariaRole: 'alertdialog',
            ariaModal: true
          })
        } else {
          this.vehicleDetails = data
        }
        this.isLoading = false
      } catch (e) {
        this.isLoading = false
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('errorMessage', errorMessage)
      }
    },
    getYear: async function () {
      try {
        this.loadingComponent = this.$buefy.loading.open()
        const { data } = await http.get(`${constants.API_URL}/api/franchiseeAcademicYears?isCurrentAcademicYear=true`)
        this.academicYears = data.rows
        const currentAcademicYear = Utils.getCurrentAcademicYear()
        let academicYear = this.academicYears.find(y => {
          return y.academicYear.trim() === currentAcademicYear.trim()
        })
        this.academicYearID = academicYear ? academicYear.id : ''

        this.loadingComponent.close()
      } catch (e) {
        this.loadingComponent.close()
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('errorMessage', errorMessage)
      }
    },
    getFranchiseeList: async function () {
      try {
        const response = await http.get(`${constants.API_URL}/api/franchisee`)
        let data = response.data
        this.franchiseeArr = data.rows
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('Error While fetching franchisee', errorMessage)
        this.lock = false
        this.hasClicked = false
        return this.$buefy.dialog.alert({
          message: errorMessage,
          type: 'is-danger',
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',

          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      }
    },
    deleteDropFile (i) {
      this.dropFile.splice(i, 1)
    },
    save: async function () {
      try {
        this.loadingComponent = this.$buefy.loading.open()
        if (this.pollutionStartDate === '') {
          this.loadingComponent.close()
          return this.$buefy.dialog.alert({
            message: 'Please Enter Start Date',
            type: 'is-danger',
            hasIcon: true,
            animation: 'zoom-out',
            size: 'is-medium',
            icon: ' mdi-exclamation',
            iconPack: 'mdi',
            ariaRole: 'alertdialog',
            ariaModal: true
          })
        }
        if (this.pollutionExpiryDate === '') {
          this.loadingComponent.close()
          return this.$buefy.dialog.alert({
            message: 'Please Enter Expiry Date',
            type: 'is-danger',
            hasIcon: true,
            animation: 'zoom-out',
            size: 'is-medium',
            icon: ' mdi-exclamation',
            iconPack: 'mdi',
            ariaRole: 'alertdialog',
            ariaModal: true
          })
        }
        let formData = new FormData()
        formData.append('vehicleID', this.vehicleID)
        formData.append('pucCost', this.pucCost)
        formData.append('pucStartDate', this.pollutionStartDate)
        formData.append('pucExpiryDate', this.pollutionExpiryDate)
        for (let i = 0; i < this.dropFile.length; i++) {
          formData.append('pollutionControlAttachements', this.dropFile[i])
        }
        // for (var pair of formData.entries()) {
        //   console.log(pair)
        // }
        this.hasClicked = true

        await http.post(`${constants.API_URL}/api/transport/vehicledetails/vehiclepollutiondetails`, formData)
        this.loader = false
        this.loadingComponent.close()
        this.$router.push({ name: 'vehiclePollution' })
        return this.$buefy.dialog.alert({
          type: 'is-success',
          message: 'Saved successfully',
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',
          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      } catch (e) {
        this.loadingComponent.close()
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('Error While Details', errorMessage)
        this.lock = false
        this.hasClicked = false
        this.loader = false
        return this.$buefy.dialog.alert({
          message: errorMessage,
          type: 'is-danger',
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',
          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      }
    },
    // onFilechange () {
    //   let r = this.dropFile.filter((a, i) => {
    //     if (this.allowedFiles.includes(a.name.split('.').pop())) {
    //     }
    //     return this.allowedFiles.includes(a.name.split('.').pop())
    //   })
    //   this.dropFile = r
    // },
    clearData () {
      this.vehicleDetails = []
      this.franchiseeID = ''
      this.vehicleID = ''
    }
  }
}
</script>
